import { RealmAccessRole } from '@aibees/shared/definition';
import { intersection } from 'lodash-es';
import { useAuthContext } from './use-auth-context';

export function useAuthCheckRealmRole(
  role?: RealmAccessRole | RealmAccessRole[],
  skipNoRole = false
) {
  const { authenticated, user } = useAuthContext();
  if (skipNoRole && !role?.length) return true;

  const roles = typeof role === 'string' ? [role] : role;
  return (
    authenticated && intersection(user?.realmAccessRoles, roles).length > 0
  );
}
